import{r as e}from"../node_modules/react-is/index.js";var p=e,r={};r[p.ForwardRef]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},r[p.Memo]={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0};
//# sourceMappingURL=hoist-non-react-statics.cjs.js.map
